import React from "react";
import { Route, Routes } from "react-router-dom";

import { ContentWrapper } from "../../common/styledComponents";
import UserSearch from "./components/UserSearch";
import EuerDeclaration from "./pages/EuerDeclaration";
import IncomeTaxDeclaration from "./pages/IncomeTaxDeclaration";
import TaxHome from "./pages/TaxHome";
import TaxPreparation from "./pages/TaxPreparation";
import TradeTaxDeclaration from "./pages/TradeTaxDeclaration";
import VatAnnualDeclaration from "./pages/VatAnnualDeclaration";

const TaxDeclaration = () => {
  const wrapWithUserSearch = (Component: React.ComponentType<{}>) => {
    return (
      <UserSearch>
        <Component />
      </UserSearch>
    );
  };

  return (
    <ContentWrapper>
      <Routes>
        <Route path="/tax-home" element={<TaxHome />} />
        <Route
          path="/tax-preparation/*"
          element={wrapWithUserSearch(TaxPreparation)}
        />
        <Route
          path="/euer-declaration/*"
          element={wrapWithUserSearch(EuerDeclaration)}
        />
        <Route
          path="/vat-annual-declaration"
          element={wrapWithUserSearch(VatAnnualDeclaration)}
        />
        <Route
          path="/trade-tax-declaration"
          element={wrapWithUserSearch(TradeTaxDeclaration)}
        />
        <Route
          path="/income-tax-declaration"
          element={wrapWithUserSearch(IncomeTaxDeclaration)}
        />
      </Routes>
    </ContentWrapper>
  );
};

export default TaxDeclaration;
